import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../environments/environmentCAS';

@Injectable({
  providedIn: 'root'
})
export class EnterpriseHistoryService {
  private readonly API_URL = environment.casApiUrl + '/api/historique-entreprise';
  private historySubject = new BehaviorSubject<any[]>([]);

  constructor(private http: HttpClient) {
    this.loadHistory();
  }

  getHistory(): Observable<any[]> {
    return this.historySubject.asObservable();
  }

  loadHistory(): void {
    this.http.get<any[]>(this.API_URL).subscribe({
      next: (data) => this.historySubject.next(data),
      error: (err) => console.error('Erreur chargement historique entreprise:', err)
    });
  }

  saveComparison(data: any): Observable<any> {
    return this.http.post<any>(this.API_URL, data);
  }

  deleteHistory(id: string | number): Observable<void> {
    return this.http.delete<void>(`${this.API_URL}/${id}`);
  }
}
